export default __webpack_public_path__ + "static/media/large.6370402b.jpg";